<app-dashboard *ngIf="component == 'Dashboard'"></app-dashboard>
